<template>
  <section
    class="page-actions"
    :aria-label="title"
  >
    <div class="page-actions__heading">
      <span
        v-if="$slots.icon"
        class="page-actions__icon">
        <slot name="icon" />
      </span>

      <div>
        <h2>{{ title }}</h2>
        <p v-if="description">{{ description }}</p>
      </div>
    </div>

    <div class="page-actions__buttons">
      <slot />

      <button
        v-for="action in actions"
        :key="action.id"
        type="button"
        :class="getActionClass(action)"
        :disabled="isDisabledAction(action)"
        @click="action.handler()"
      >
        <component
          v-if="action.icon"
          :is="action.icon"
          :size="17"
          aria-hidden="true"
        />
        {{ action.label }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BlockButtons',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getActionClass (action) {
      return { 'is-primary': action.primary }
    },
    isDisabledAction (action) {
      return this.disabled || action.disabled
    },
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
